module.exports = __webpack_public_path__ + "media/images/icons/eyedropper-36d7508aeb8f66d44d02afa44258c9a4.svg";